import React, { useState } from "react";
import { Button, Typography, Box } from "@mui/material";
import { LearnersSinglelogin } from "./base_url";

const Singlelogin = ({ videoUrl }) => {
  const [error, setError] = useState("");
  const token = localStorage.getItem("token");

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const response = await fetch(`${LearnersSinglelogin}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ videoUrl }),
      });

      if (response.ok) {
        const ssoUrl = await response.text();
        window.open(ssoUrl, "_blank");
      } else {
        setError("Login failed. Please try again.");
      }
    } catch (error) {
      //console.error("Login error:", error);
      setError("Something went wrong. Please try again later.");
    }
  };

  return (
    <Box component="form" onSubmit={handleLogin} sx={{ width : "100%", mt: 2 }}>
      {error && (
        <Typography color="error" sx={{ mb: 1 }}>
          {error}
        </Typography>
      )}

      <Button
        type="submit"
        fullWidth
        variant="outlined"
        sx={{
          color: "rgb(27, 110, 244)",
          fontWeight: 700,
          fontSize: "16px",
          paddingY: "6px",
          borderColor: "rgb(27, 110, 244)",
          borderRadius: "10px",
          textTransform: "none",
          "&:hover": {
            backgroundColor: "#f0f4ff",
            borderColor: "rgba(0, 98, 255, 1)",
            color: "rgba(0, 98, 255, 1)",
          },
        }}
      >
        Start Learning Now
      </Button>
    </Box>
  );
};

export default Singlelogin;
